import { render, staticRenderFns } from "./AttractionDetails.vue?vue&type=template&id=37040c1c&scoped=true&"
import script from "./AttractionDetails.vue?vue&type=script&lang=js&"
export * from "./AttractionDetails.vue?vue&type=script&lang=js&"
import style0 from "./AttractionDetails.vue?vue&type=style&index=0&id=37040c1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37040c1c",
  null
  
)

export default component.exports